import cx from 'classnames';
import React from 'react';
import { useId } from '../index.js';
export const FormInputOption = ({ children, className, id, inputRef, label, labelProps, leading, showVisualCheckbox, trailing, type = 'checkbox', variant, ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { className: "tds-form-input-hidden-choice", id: htmlId, ref: inputRef, type: type, ...rest }),
        React.createElement("label", { className: cx('tds-form-input', 'tds-form-input--option', {
                [`tds-form-input--${variant}`]: variant,
            }, className), htmlFor: htmlId, ...labelProps },
            (leading || showVisualCheckbox) && (React.createElement("span", { className: "tds-form-input-leading" },
                (showVisualCheckbox !== null && showVisualCheckbox !== void 0 ? showVisualCheckbox : type === 'checkbox') && (React.createElement("span", { className: "tds-form-input-visual-checkbox" })),
                leading)),
            children || label,
            trailing && React.createElement("span", { className: "tds-form-input-trailing" }, trailing))));
};
